// extracted by mini-css-extract-plugin
export default {"icon":"CopyIcon_icon__PMYQu"};